import React, { Component } from 'react'

import { getHighestLevel } from '@global/helpers/helpers'

import CounterRow from '../CounterRow'
import Table from './components/Table'

import './styles.scss'

export default class AssignedTenders extends Component {
    render() {
        const { summary, block, module, id, level, locale, customData } = this.props

        const parsedLevel = getHighestLevel(level)

        return (
            <div className={'assigned-tenders-wrapper'}>
                <CounterRow summary={summary} selector={'assigned'} />
                {parsedLevel > 20 && (
                    <div className={'table-wrapper'}>
                        <Table
                            block={block}
                            module={module}
                            customData={customData}
                            id={id}
                            level={level}
                            locale={locale}
                        />
                    </div>
                )}
            </div>
        )
    }
}
